<template>
    <div id="EmploymentHistorySection">
        <div class="card">
            <div class="card-body">
                <div class="d-flex align-items-center mb-4">
                    <h5 class="card-title flex-grow-1 mb-0">Employment History</h5>
                    <div class="flex-shrink-0">
                        <button
                            @click="formContext.modal = true"
                            class="btn btn-primary"
                            type="button">
                            Add <span class="d-none d-sm-inline">History</span>
                        </button>
                    </div>
                </div>
                <CommonSpinner v-if="isLoading" />
                <div v-else class="row g-4">
                    <div
                        v-for="(data,index) in pageData.data"
                        :key="index"
                        class="col-lg-6">
                        <div class="card border mb-0">
                            <div class="card-body p-3">
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <h5 class="mb-1">{{ data.position }}</h5>
                                        <p class="text-muted mb-1">
                                            {{ data.employer }}
                                        </p>
                                        <p class="mb-1">
                                            <strong>Grade Level:</strong>
                                            {{ data.grade_level || '-' }}
                                        </p>
                                        <p class="mb-1">
                                            <strong>Nature of Appointment:</strong>
                                            {{ data.appointment_type || '-' }}
                                        </p>
                                        <p class="mb-2">
                                            <strong>Duration:</strong>
                                            {{ $filters.date(data.start_date)  }}
                                            -
                                            {{ data.end_date ? $filters.date(data.end_date) : 'Present' }}
                                        </p>
                                        <p
                                            v-if="data.responsibilities"
                                            class="mb-0">
                                            {{ data.responsibilities }}
                                        </p>
                                    </div>
                                    <div class="dropdown dropstart no-arrow">
                                        <button
                                            class="dropdown-toggle btn btn-sm rounded-circle btn-primary"
                                            type="button"
                                            data-bs-toggle="dropdown">
                                            <i class="ri-more-2-fill"></i>
                                        </button>
                                        <ul class="dropdown-menu">
                                            <li>
                                                <button
                                                    class="dropdown-item"
                                                    @click.prevent="openEditView(data)">
                                                    Edit
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p v-if="!pageData.data.length">
                        No employment history added.
                    </p>
                </div>
            </div>
        </div>
        <b-modal
            v-model="formContext.modal"
            size="lg"
            centered
            hide-footer
            title-class="fs-6"
            :title="formContext.editMode ? 'Update Employment History' : 'Add Employment History'"
            @hide="closeEditView()">

            <employment-history-form
                v-if="formContext.modal"
                :edit-mode="formContext.editMode"
                :edit-item="formContext.item"
                @closeMe="closeEditView()"
                @addedItem="addItem"
                @updatedItem="updateItem" />
        </b-modal>
    </div>
</template>


<script>
import EmploymentHistoryForm from "@/components/forms/EmploymentHistoryForm.vue";
import { commonEditViewMixin } from "@/mixins/commonEditViewMixin";
import { commonPaginationMixin } from '@/mixins/commonPaginationMixin';

export default {
    components:{
        EmploymentHistoryForm
    },
    mixins:[
        commonEditViewMixin,
        commonPaginationMixin
    ],
    data(){
        return{
            isLoading:false,
        }
    },
    methods:{
        addItem(item){
            this.pageData.data.unshift(item);
        },
        updateItem(item){
            const index = this.pageData.data.findIndex(i=>i.id==item.id);
            Object.assign(this.pageData.data[index],item);
        },
        fetchItems(){
            this.isLoading=true;
            this.$http.get("/employment-histories")
            .then(response=>{
                this.isLoading=false;
                if(response.data.success){
                    this.pageData = response.data.data;
                }
            });
        }
    },
    created(){
        this.fetchItems();
    }
}
</script>